import { render, staticRenderFns } from "./Company_roles.vue?vue&type=template&id=3158d5a2&scoped=true&lang=pug&"
import script from "./Company_roles.vue?vue&type=script&lang=coffee&"
export * from "./Company_roles.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158d5a2",
  null
  
)

export default component.exports